<template>
  <footer class="pt-20 sm:block hidden border-t border-gray-100 bg-white">
    <div class="max-w-7xl mx-auto px-8 py-16">
      <div class="md:flex md:justify-between items-start">
        <div class="mb-10 md:mb-0">
          <NuxtLink :to="$localePath('/')" class="flex items-center">
            <img
              src="@/assets/logo.webp"
              class="h-10 md:h-12 mb-1"
              alt="MEDIUM.am Logo"
            />
          </NuxtLink>
          <p class="text-sm w-full leading-relaxed text-gray-600">
            {{ $t("footer.tagline") }}
          </p>
        </div>

        <div class="grid grid-cols-2 gap-12 sm:gap-20">
          <div>
            <h2 class="mb-6 text-base font-bold text-primary">
              {{ $t("footer.gallery") }}
            </h2>
            <ul class="space-y-4 text-base">
              <li>
                <NuxtLink
                  :to="$localePath('/gallery')"
                  class="hover:text-primary-blue transition-colors"
                  >{{ $t("footer.recent") }}</NuxtLink
                >
              </li>
              <li>
                <NuxtLink
                  :to="$localePath('/gallery')"
                  class="hover:text-primary-blue transition-colors"
                  >{{ $t("footer.creators") }}</NuxtLink
                >
              </li>
            </ul>
          </div>

          <div>
            <h2 class="mb-6 text-base font-bold text-primary">
              {{ $t("footer.legal") }}
            </h2>
            <ul class="space-y-4 text-base">
              <li>
                <NuxtLink
                  :to="$localePath('/privacy')"
                  class="hover:text-primary-blue transition-colors"
                  >{{ $t("footer.privacy") }}</NuxtLink
                >
              </li>
              <li>
                <NuxtLink
                  :to="$localePath('/terms')"
                  class="hover:text-primary-blue transition-colors"
                  >{{ $t("footer.terms") }}</NuxtLink
                >
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div
        class="mt-16 pt-8 border-t border-gray-50 flex flex-col md:flex-row justify-between items-center gap-4 text-base"
      >
        <span class="text-sm text-gray-500 italic">
          © {{ currentYear }} MEDIUM.am Owned and operated by Artush Aleksanyan.
          <span class="capitalize">{{ $t("footer.rights") }}.</span>
        </span>

        <div class="flex items-center gap-6">
          <a
            target="_blank"
            href="https://www.facebook.com/profile.php?id=100090263893421"
            class="hover:text-primary-blue transition-colors font-bold"
            >Facebook</a
          >
          <a
            target="_blank"
            href="https://www.instagram.com/mediumam_art/"
            class="hover:text-primary-blue transition-colors font-bold"
            >Instagram</a
          >
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { ref } from "vue";

const currentYear = ref(new Date().getFullYear());
</script>
